import { useVhcCreateForm } from './hooks/useVhcCreateForm';
import { useVhcCreateLookupForm } from './hooks/useVhcCreateLookupForm';
import st from './styles.module.scss';
import { BranchType, VarClassEnum } from 'api/generated';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useIsInIframe } from 'features/vhc/hooks/use-is-in-Iframe';
import { FC, useEffect } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const VhcCreatePage: FC = () => {
  const { wipId: wipIdUrlParam, branchId: branchIdUrlParam } = useParams<{ wipId: string; branchId: string }>();

  const isInIframe = useIsInIframe();
  const { control, handleSubmit, errors, isValid, setValue, trigger, onSubmit, handleClose, isCreating } =
    useVhcCreateForm();

  const {
    lookUpControl,
    lookUpErrors,
    lookUpIsValid,
    refetchLookup,
    lookUpWatch,
    isLookingUp,
    branchId,
    setLookUpValue
  } = useVhcCreateLookupForm();

  const lookUpWipId = lookUpWatch('input');
  const lookUpbranchId = lookUpWatch('branchId');

  const handleLookUp = async () => {
    try {
      const { data } = await refetchLookup();
      if (data) {
        const { vehicle, soHeaderWipNo, customerName, soHeaderId } = data;

        setValue('wipNo', soHeaderWipNo?.toString() ?? '');
        setValue('regNo', vehicle?.regNo?.toString() ?? '');
        setValue('mileage', vehicle?.mileage ?? undefined);
        setValue('varclass', vehicle?.varClass ?? VarClassEnum.NotChosen);
        // setValue('warranty', vehicle?.warranty ?? '');
        setValue('carDescription', vehicle?.description ?? '');
        setValue('vin', vehicle?.vin ?? '');
        setValue('customerName', customerName ?? '');
        setValue('soHeaderId', soHeaderId ?? 0);
        setValue('branchId', branchId ?? 0);

        await trigger();
      }
    } catch (error) {
      toast.error('Error looking up vehicle details');
    }
  };

  useEffect(() => {
    if (wipIdUrlParam) {
      setLookUpValue('input', wipIdUrlParam, { shouldValidate: true });
    }
    if (branchIdUrlParam) {
      setLookUpValue('branchId', Number(branchIdUrlParam), { shouldValidate: true });
    }
  }, [wipIdUrlParam, branchIdUrlParam]);

  useEffect(() => {
    if (lookUpWipId && lookUpbranchId) handleLookUp();
  }, [lookUpWipId, lookUpbranchId]);

  return (
    <Card className="border-0 shadow-sm py-10">
      <Card.Header
        className="p-0 px-10  d-flex fw-bold justify-content-between pb-6 fs-5 text-gray-700 align-items-center"
        style={{ minHeight: '0' }}
      >
        <div>VHC Record</div>

        {!isInIframe && (
          <div onClick={handleClose} className="d-flex align-items-center justify-content-center cursor-pointer">
            <InlineSvg path="/media/icons/custom/cross-circle.svg" className="svg-icon-1 me-1" />
          </div>
        )}
      </Card.Header>

      <Card.Body className="p-0 px-10 pt-6">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className={clsx(st.lookupContainer)}>
            <div className={clsx(st.group)}>
              <Form.Label>Reg / WIP No</Form.Label>
              <Controller
                name="input"
                control={lookUpControl}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    placeholder="Enter Reg / WIP No "
                    isInvalid={!!lookUpErrors.wip}
                    className="form-control py-0 h-40px"
                  />
                )}
              />
            </div>
            <div className={clsx(st.group)}>
              <Form.Label>Branch</Form.Label>
              <Controller
                name="branchId"
                control={lookUpControl}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Select
                    {...field}
                    placeholder="Enter registration or WIP number"
                    isInvalid={!!lookUpErrors.wip}
                    className="form-control-solid py-0 h-40px"
                  >
                    <option key={-1} value="">
                      Select Branch
                    </option>
                    {Object.entries(BranchType)
                      .filter(([key]) => isNaN(Number(key)))
                      .map(([key, value]) => (
                        <option key={key} value={value}>
                          {BranchType[value]}
                        </option>
                      ))}
                  </Form.Select>
                )}
              />
            </div>
            <Button
              variant="danger"
              className={`${st.lookupButton}`}
              onClick={handleLookUp}
              disabled={!lookUpIsValid || !branchId || isLookingUp}
            >
              <InlineSvg path="/media/icons/duotune/general/gen021.svg" className="svg-icon-5 me-1" />
              {isLookingUp ? 'Loading...' : 'Look Up'}
            </Button>
          </Form.Group>
          <div className="row">
            <div className="col-sm-12 col-md-9 mt-10">
              <div className="fs-13 fw-700 text-black p-4 rounded w-100 " style={{ backgroundColor: '#F6F6F6' }}>
                Look Up WIP or Reg Number first
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-6 mt-4">
              <div className={st.block}>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>WIP Number</Form.Label>
                  <Controller
                    name="wipNo"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control {...field} isInvalid={!!errors.wipNo} readOnly className="form-control-solid" />
                    )}
                  />
                </Form.Group>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>Registraton</Form.Label>
                  <Controller
                    name="regNo"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control {...field} isInvalid={!!errors.regNo} readOnly className="form-control-solid" />
                    )}
                  />
                </Form.Group>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>Mileage</Form.Label>
                  <Controller
                    name="mileage"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control {...field} value={field.value ?? ''} type="number" isInvalid={!!errors.mileage} />
                    )}
                  />
                </Form.Group>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>Vehicle Class</Form.Label>
                  <Controller
                    name="varclass"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Select
                        {...field}
                        value={field.value ?? ''}
                        isInvalid={!!errors.varclass}
                        aria-readonly
                        className="form-select-solid"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => e.preventDefault()}
                        style={{ pointerEvents: 'none' }}
                      >
                        {Object.entries(VarClassEnum).map(([key, value]) => (
                          <option key={key} value={value}>
                            {VarClassEnum[value]}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 mt-4">
              <div className={st.block}>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>Model</Form.Label>
                  <Controller
                    name="carDescription"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        as="textarea"
                        rows={1}
                        {...field}
                        isInvalid={!!errors.regNo}
                        readOnly
                        className="form-control-solid"
                      />
                    )}
                  />
                </Form.Group>
                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>VIN</Form.Label>
                  <Controller
                    name="vin"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        value={field.value ?? ''}
                        isInvalid={!!errors.vin}
                        readOnly
                        className="form-control-solid"
                      />
                    )}
                  />
                </Form.Group>
                {/* <div className="col-md-6 mb-3">
                  <Form.Group>
                    <Form.Label>Warranty</Form.Label>
                    <Controller
                      name="warranty"
                      control={control}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          value={field.value ?? ''}
                        />
                      )}
                    />
                  </Form.Group>
                </div> */}

                <Form.Group className={clsx(st.groupRow)}>
                  <Form.Label>Customer</Form.Label>
                  <Controller
                    name="customerName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        value={field.value ?? ''}
                        isInvalid={!!errors.customerName}
                        readOnly
                        className="form-control-solid"
                      />
                    )}
                  />
                </Form.Group>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div className="d-flex justify-content-start">
            <Button variant="primary" type="submit" className="me-2" disabled={!isValid}>
              {isCreating ? 'Loading...' : 'Create VHC Record'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};
